import type { BackwardsCompatibleMutableRefObject } from '@adsk/alloy-react-helpers';

import { isElementWithinRef } from './isElementWithinRef';

export const getSharedFooterProps = ({
  id,
  refToFocusOnClear,
  closeMenu,
  reset,
}: {
  id: string;
  reset: () => void;
  closeMenu: () => void;
  refToFocusOnClear: BackwardsCompatibleMutableRefObject<HTMLElement>;
}) => {
  const onBlur = (event: React.FocusEvent<HTMLElement>) => {
    // If we're focusing on the target (control), don't close the dropdown
    // If we aren't focusing the control, we're probably tabbing to the next component
    // So we should close the menu
    if (
      isElementWithinRef({
        ref: refToFocusOnClear,
        element: event.relatedTarget,
      })
    ) {
      return;
    }

    closeMenu();
  };

  const onClear = () => {
    reset();
    refToFocusOnClear.current?.focus();
  };

  const onMouseDown = (event: React.MouseEvent<HTMLButtonElement>) => {
    // Prevent the menu from closing when anything is clicked in the footer
    event.preventDefault();
  };

  return {
    onBlur,
    onClear,
    onMouseDown,
    id: `${id}-dropdown-footer`,
    ['data-testid']: 'dropdown-footer',
  };
};
